import { AttacherSolverSettings } from "@animech/supermodel";
import { AttacherSolverContext } from "./attacher-solver-context";
import { createSubsolutionEvaluators } from "./subsolution-evaluators";
import { createSubsolutionFilter } from "./subsolution-filter";
import { createAttacherFilter } from "./attacher-filter";
import { createAttachmentFilter } from "./attachment-filter";
import { createAttachmentDeltaPositionFilter } from "./attachment-delta-position-filter";
import { createAttachmentProjectionModifier } from "./attachment-projection-modifier";
import { createAttachmentRotationAxisFilter } from "./attachment-rotation-axis-filter";

export function createAttacherSolverSettings(
	context: AttacherSolverContext,
): Omit<AttacherSolverSettings, "attacherNodesByEntityLookup"> {
	return {
		attachmentDistanceErrorMargin: 0.01,
		attachmentRotationErrorMargin: 0.01,
		attachmentRotationAxisIds: createAttachmentRotationAxisFilter(context),
		attacherFilter: createAttacherFilter(context),
		attachmentFilter: createAttachmentFilter(context),
		attachmentDeltaPositionFilter: createAttachmentDeltaPositionFilter(context),
		subsolutionFilter: createSubsolutionFilter(context),
		subsolutionEvaluators: createSubsolutionEvaluators(context),
		attachmentProjectionModifier: createAttachmentProjectionModifier(context),
	};
}
